module.exports = __webpack_public_path__ + "img/marker_two_green3.33c96a18.png";